var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recurring-order-day-selector"},_vm._l((_vm.days),function(day,i){return _c('button',{key:'day-' + i,class:{ active: _vm.eDays.includes(i), blocked: day.blocked },on:{"click":function($event){return _vm.selectDay(day)}}},[_vm._v(" "+_vm._s(day.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }